/**
 * EventMatcher — Pattern bazlı event matching (`chat:{id}:messages` gibi dinamik event'ler).
 *
 * Saf fonksiyonel: state tutmaz, regex + paramNames alır, match sonucunu döner.
 */

export interface MatchResult {
  matched: boolean;
  params: Record<string, string>;
}

export function matchEvent(event: string, pattern: RegExp, paramNames: readonly string[]): MatchResult {
  const m = event.match(pattern);
  if (!m) return { matched: false, params: {} };
  const params: Record<string, string> = {};
  paramNames.forEach((name, i) => {
    const val = m[i + 1];
    if (val !== undefined) params[name] = val;
  });
  return { matched: true, params };
}
